import { useContext } from "react";
import AuthorizationChangedDialogContext from "context/authorizationChangedDialogContext";

function useAuthorizationChangedDialog() {
  return useContext(AuthorizationChangedDialogContext);
}

export default useAuthorizationChangedDialog;
